import { faPlus } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal";
import COLORS from "../../../data/colors";
import Listing from "../components/Listing";
import { Col, Form, Row } from "react-bootstrap";
import "./../index.scss";
import Select from "../../../components/Select";
import { useRef, useState } from "react";
import PlacesAutocomplete from "../components/PlacesAutocomplete";
import GET_DEALS from "../../../graphql/queries/erasmusapp/getDeals";
import { useMutation, useQuery } from "@apollo/client";
import ADD_DEAL from "../../../graphql/mutations/erasmusapp/addDeal";
import { toast, ToastContainer } from "react-toastify";
import toastConfiguration from "../../../data/toastConfiguration";
import { erasmusPlusTags, programmeList, mobilityPhaseList } from "../../../data/erasmusPlusListData";
import DELETE_DEAL from "../../../graphql/mutations/erasmusapp/deleteDeal";
import { handleFileRead, getFilterValueForMultiSelectField } from "../components/CommonFunctions";
import MultiSelect from "../../../components/MultiSelect";

const Deals = () => {
    const [showModal, setShowModal] = useState(false)
    const [validated, setValidated] = useState(false)
    const [title, setTitle] = useState(null)
    const [summary, setSummary] = useState(null)
    const [moreInfo, setMoreInfo] = useState(null)
    const [website, setWebsite] = useState(null)
    const [image, setImage] = useState(null)
    const [address, setAddress] = useState(null)
    const [city, setCity] = useState(null)
    const [country, setCountry] = useState(null)
    const [latLng, setLatLng] = useState(null)
    const [condition, setCondition] = useState(null)
    const [programme, setProgramme] = useState(null)
    const [mobilityPhase, setMobilityPhase] = useState(null)
    const [tags, setTags] = useState([])
    const [invalidImageLength,setInvalidImageLength] = useState(false);

    const formRef = useRef(null);
    const { data, error, loading, refetch } = useQuery(GET_DEALS);

    const [addDeal, { loading: loadingAddDeal }] = useMutation(ADD_DEAL);

    const [deleteDeal, { loading: loadingDeleteDeal }] = useMutation(DELETE_DEAL);

    const formIsValidated = (e) => {
        setValidated(true);
        e.preventDefault();

        if (!formRef.current.checkValidity()) {
            e.stopPropagation();
            return false;
        }

        return true;
    };


    const handleAdd = async (e) => {
        if (!formIsValidated(e)) return;

        const toastId = toast.loading("Creating deal...", toastConfiguration);
        try {
            const result = await addDeal({
                variables: {
                    dealInput: {
                        title: title,
                        body: { summary: summary, value: moreInfo },
                        city: null,
                        country: null,
                        conditions: condition,
                        image: image,
                        programmes: programme,
                        mobilityPhases: mobilityPhase,
                        tags: tags,
                        website: website,
                        location: { "address": address, "geolocation": latLng }
                    }
                }
            });
            if (result?.data?.addDeal) {
                toast.update(toastId, {
                    ...toastConfiguration,
                    render: `Successfully created the deal`,
                    type: "success",
                    isLoading: false,
                });
                refetch();
                handleCloseModal();
            }
            else {
                toast.update(toastId, {
                    ...toastConfiguration,
                    render: `Could not create the deal`,
                    type: "error",
                    isLoading: false,
                });
            }
        } catch (err) {
            toast.update(toastId, {
                ...toastConfiguration,
                render: `Could not create the deal`,
                type: "error",
                isLoading: false,
            });
        }
    };

    const handleDelete = async (id, externalID) => {

        const toastId = toast.loading("Deleting deal...", toastConfiguration);
        try {
            const result = await deleteDeal({
                variables: {
                    id: id,
                    externalID: externalID
                }
            });
            if (result?.data?.deleteDeal) {
                toast.update(toastId, {
                    ...toastConfiguration,
                    render: `Successfully delete the deal`,
                    type: "success",
                    isLoading: false,
                });
                refetch();
            }
            else {
                toast.update(toastId, {
                    ...toastConfiguration,
                    render: `Could not delete the deal`,
                    type: "error",
                    isLoading: false,
                });
            }
        } catch (err) {
            toast.update(toastId, {
                ...toastConfiguration,
                render: `Could not delete the deal`,
                type: "error",
                isLoading: false,
            });
        }
    };

    const handleCloseModal = () => {
        setTitle("");
        setSummary("");
        setMoreInfo("");
        setWebsite("");
        setImage(null);
        setAddress("");
        setCity("");
        setCountry("");
        setLatLng("");
        setCondition("");
        setProgramme(null);
        setMobilityPhase(null);
        setTags([]);
        setShowModal(false);
        setValidated(false);
    }

    return (
        <div>
            <Listing data={data?.deals} changeShowModal={() => setShowModal(!showModal)} type={"Deal"} loading={loading} error={error} handleDelete={(id, externalID) => handleDelete(id, externalID)} />
            <CustomModal
                size={"lg"}
                show={showModal}
                handleClose={handleCloseModal}
                disabledCancelButton={loadingAddDeal}
                bodyClassName="modal-body"
                body={
                    (
                        <div>
                            <Form validated={validated} noValidate onSubmit={() => setValidated(true)} ref={formRef}>
                                <div className='group-fields-title mb-2' style={{ color: "#3D619C", marginTop: 15, marginLeft: 20 }}>
                                    Event Details
                                </div>
                                <Row style={{ marginBottom: 12, marginLeft: 25, marginRight: 25 }}>
                                    <Form.Group className="mb-3" controlId="formRoleName">
                                        <Form.Label>Title <span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control
                                            placeholder="Title"
                                            value={title}
                                            required
                                            onChange={(e) => setTitle(e.target.value)}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a title.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formRoleName">
                                        <Form.Label>Short Summary <span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            placeholder=""
                                            value={summary}
                                            required
                                            onChange={(e) => setSummary(e.target.value)}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a description.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formRoleName">
                                        <Form.Label>More Information For The Student <span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            placeholder=""
                                            value={moreInfo}
                                            required
                                            onChange={(e) => setMoreInfo(e.target.value)}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a description.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formRoleName">
                                        <Form.Label>Website</Form.Label>
                                        <Form.Control
                                            placeholder="Website"
                                            value={website}
                                            pattern='https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)'
                                            onChange={(e) => setWebsite(e.target.value)}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a valid website.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formRoleName">
                                    <Form.Label>Image (Max Size: 4 MB)</Form.Label>
                                        <Form.Control
                                            type="file"
                                            accept=".png,.jpg,.jpeg"
                                            isInvalid={invalidImageLength}
                                            onChange={(e) => handleFileRead(e,setImage,setInvalidImageLength)}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a valid image file with maximum size 4MB.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Row>
                                <div className='group-fields-title mt-4 mb-2' style={{ color: "#3D619C", marginTop: 15, marginLeft: 20 }}>
                                    Where
                                </div>
                                <Row style={{ marginBottom: 12, marginLeft: 25, marginRight: 25 }}>
                                    <Form.Group className="mb-3" controlId="formRoleName">
                                        <Form.Label>Location <span style={{ color: "red" }}>*</span></Form.Label>
                                        <PlacesAutocomplete validated={validated}
                                            address={address}
                                            setLocation={(address, city, country, latLng) => {
                                                setAddress(address)
                                                setCity(city)
                                                setCountry(country)
                                                setLatLng(latLng);
                                            }} />

                                        <Form.Control.Feedback type="invalid">
                                            Please provide a location.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Row>

                                <div className='group-fields-title mt-4 mb-2' style={{ color: "#3D619C", marginTop: 15, marginLeft: 20 }}>
                                    For whom
                                </div>
                                <Row style={{ marginBottom: 12, marginLeft: 25, marginRight: 25 }}>
                                    <Col md={4}>
                                        <div style={{ marginBottom: 5, marginTop: 10 }} className='label-style'>
                                            <Form.Group className="col-12" controlId="formBasicName">

                                                <Form.Label>Condition <span style={{ color: "red" }}>*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    onChange={(event) => setCondition(event?.target?.value)}
                                                    required
                                                    value={condition}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Not valid
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                    </Col>

                                    <Col md={4}>
                                        <div style={{ marginBottom: 5, marginTop: 10 }} className='label-style'>
                                            <Form.Group className="mb-3" controlId="formRoleName">
                                                <Form.Label>Programme  <span style={{ color: "red" }}>*</span></Form.Label>
                                                <Select
                                                    options={programmeList?.map((el) => ({
                                                        value: el,
                                                        label: el
                                                    }))}
                                                    placeholder="Select programme"
                                                    onChange={(event) => setProgramme(event?.value)}
                                                    validated={validated}
                                                    invalid={!programme}
                                                    value={{
                                                        "label": programme
                                                    }}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Please provide a programme.
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div style={{ marginBottom: 5, marginTop: 10 }} className='label-style'>
                                            <Form.Group className="mb-3" controlId="formRoleName">
                                                <Form.Label>Mobility Phase  <span style={{ color: "red" }}>*</span></Form.Label>
                                                <Select
                                                    options={mobilityPhaseList?.map((el) => ({
                                                        value: el,
                                                        label: el
                                                    }))}
                                                    placeholder="Select mobility phase"
                                                    onChange={(event) => setMobilityPhase(event?.value)}
                                                    validated={validated}
                                                    invalid={!mobilityPhase}
                                                    value={{
                                                        "label": mobilityPhase
                                                    }}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Please provide a mobility phase.
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                    </Col>
                                    <Form.Group className="mb-3" controlId="formRoleName">
                                        <Form.Label>Tags</Form.Label>                       
                                        <MultiSelect
                                            value={getFilterValueForMultiSelectField(tags)}
                                            onChange={(item) => {
                                                const tempTags = item.map((i) => i.label);
                                                setTags(tempTags)
                                                
                                            }}
                                            options={erasmusPlusTags?.filter(
                                                (x) => !tags.find((x2) => x === x2)
                                            )?.map((el) => ({
                                                value: el,
                                                label: el
                                            }))}
                                            placeholder="Select one or more tags..."
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a tag.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <div className="modal-body-text">
                                        Only submit content that you own. By submitting an update, you warrant that you have all the necessary rights to use and license the content and that this does not violate, misappropriate or infringe any law or any third parties' rights, including, without limitation, privacy rights and copyright. See more information in Terms and Conditions and Privacy Policy.
                                    </div>
                                </Row>
                            </Form>
                        </div>
                    )
                }
                button={
                    <CustomButton
                        buttonType={"primary"}
                        disabled={loadingAddDeal}
                        text={"Publish deal"}
                        icon={faPlus}
                        hasIcon={true}
                        iconColor={COLORS.white}
                        handleClick={handleAdd}
                    />

                }
                title={
                    <div>Add a new <span style={{ color: "#3D619C" }}>Deals</span></div>
                }
                subtitle={
                    ""
                }
                hasIcon
                fullscreen
            />
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
};

export default Deals;
